import * as React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { FormControl, Input, TextField } from '@mui/material';
import HelloUser from './HelloUser';

interface HeaderProps {
  sections: ReadonlyArray<{
    title: string;
    url: string;
  }>;
  title: string;
}

const LoginForm = ({ setName }: any) => {
  const ref = React.useRef(null);
  console.log(ref.current);
  return <FormControl style={{flexDirection:'row'}}>
    <TextField style={{margin: '10px'}} id="signup-input-tag" placeholder="UserName" inputRef={ref} />
    <Button id="send-login-form" onClick={() => setName((ref?.current as any)?.value)}>Go!</Button>
  </FormControl>
}

export default function Header(props: HeaderProps) {
  const { sections, title } = props;
  const [hasTag, setHasTag] = React.useState(false);
  const [name, setName] = React.useState(null);
  const signUp = () => {
    setHasTag(true);
  };

  return (
    <React.Fragment>
      <Toolbar sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <HelloUser/>
        <Button sx={{marginLeft: "10px", paddingBottom: 0}} size="small">Subscribe</Button>
        <Typography
          component="h2"
          variant="h5"
          color="inherit"
          align="center"
          noWrap
          sx={{ flex: 1 }}
        >
          {title}
        </Typography>
        <Typography
          id="login-name"
          component="h2"
          variant="h6"
          color="inherit"
          align="center"
          noWrap
          sx={{ flex: 1 }}
        >
          {name ? `Hello, ${name}` : ''}
        </Typography>
        <IconButton>
          <SearchIcon />
        </IconButton>
        <Button variant="outlined" size="small" onClick={signUp}>
          Sign up
        </Button>
        {hasTag ? <LoginForm setName={setName} /> : ''}
      </Toolbar>
      <Toolbar
        component="nav"
        variant="dense"
        sx={{ justifyContent: 'space-between', overflowX: 'auto' }}
      >
        {sections.map((section) => (
          <Link
            color="inherit"
            noWrap
            key={section.title}
            variant="body2"
            href={section.url}
            sx={{ p: 1, flexShrink: 0 }}
          >
            {section.title}
          </Link>
        ))}
      </Toolbar>
    </React.Fragment>
  );
}
